<template>
    <div style="width:100%;heigh:100%;" class="qr-msg">
        <el-card class="table-card" style="height: 830px;">
            <el-table :data="tableData" stripe style="width: 100%" class="deviceTable" border >
                <el-table-column prop="ruleType" label="类型" :formatter="parseType" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="ruleType" label="条码规则" :formatter="parseRuleType" min-width="200" show-overflow-tooltip></el-table-column>
                <el-table-column prop="codeType" label="条码类型" :formatter="parseCodeType" min-width="140" show-overflow-tooltip></el-table-column>
                <el-table-column prop="gmtModified" label="更新时间" :formatter="parseTime" min-width="110" show-overflow-tooltip></el-table-column>
                <el-table-column prop="userName" label="操作人" min-width="80" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button v-if='permission.btn_codeRule_updateCodeRule' @click="showEdit(scope.row)" type="text" size="small" >编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-dialog center :title="showTitle" @close="closeEdit"  style="z-index:99999999999" :close-on-click-modal="false" :visible.sync="editDialogVisible" :width="(span==5?'40%':'56%')" >
            <el-row :gutter="20">
                <el-col style='display:flex' :span='14' :offset='5' v-if='editForm.type!=3'>
                    <span style="line-height: 36px;">条码规则：</span>

                    <el-select v-if='editForm.type==0' v-model='editForm.rule[0].ruleGenerateType' disabled  class="value" size="small"  placeholder="" >
                        <el-option  :key="5" label="订单编号" :value="5"></el-option>
                    </el-select>

                    <el-select v-if='editForm.type==1' v-model='editForm.rule[0].ruleGenerateType' disabled class="value" size="small"  placeholder="" >
                        <el-option  :key="3" label="物料编码" :value="3"></el-option>
                    </el-select>

                    <el-select style='margin-right:20px' v-if='editForm.type==2' v-model='editForm.rule[0].ruleGenerateType' disabled class="value" size="small"  placeholder="" >
                        <el-option  :key="5" label="物料编码" :value="3"></el-option>
                    </el-select>
                    <el-select v-if='editForm.type==2' v-model='editForm.rule[1].ruleGenerateType' class="value" size="small"  placeholder="" >
                        <el-option v-for="item in selectOption" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-if="editForm.type==4" v-model="editForm.rule[0].ruleGenerateType" disabled class="value" size="small" placeholder="">
                        <el-option :key="6" label="工具编号" :value="6"></el-option>
                    </el-select>
                </el-col>
                <el-col style='display:flex' :span='isSmall?22:18' :offset='isSmall?1:4' v-else>
                    <span style="line-height: 36px;">条码规则：</span>
                    <el-select style='margin-right:20px' v-if='editForm.type==3' @change="selectChange($event,1)" v-model='editForm.rule[0].ruleGenerateType' class="value" size="small"  placeholder="" >
                        <el-option v-for="item in selectOption1" :disabled="item.disabled" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                    <el-select style='margin-right:20px' v-if='editForm.type==3' @change="selectChange($event,2)" v-model='editForm.rule[1].ruleGenerateType' class="value" size="small"  placeholder="" >
                        <el-option v-for="item in selectOption2" :disabled="item.disabled" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                    <el-select v-if='editForm.type==3' @change="selectChange($event,3)" v-model='editForm.rule[2].ruleGenerateType' class="value" size="small"  placeholder="" >
                        <el-option v-for="item in selectOption3" :disabled="item.disabled" :key="item.value" :label="item.name" :value="item.value"></el-option>
                    </el-select>

                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span='editForm.type==3?(isSmall?22:18):14' :offset='editForm.type==3?(isSmall?1:4):5' >
               
                    <span >条码形式：</span>
                    <el-select  class="value" v-model="editForm.codeType" size="small"  placeholder="条码形式" >
                        <el-option  :key="0" label="二维码" :value="0"></el-option>
                        <el-option  :key="1" label="条形码" :value="1"></el-option>
                    </el-select>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer" style="margin-top:30px; margin-bottom:50px">
                <el-button type="primary" @click="updateEdit">确 定</el-button>
                <el-button  @click="closeEdit">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'QRCodeConfig',
	data () {
        return {
            typeOption:['订单','物料','工艺','订单工艺','工具','流转卡'],
            codeTypeOption:['二维码','条形码'],
            ruleTypeOption:['生成时间(年 月 日)','生成时间(时 分 秒)','顺序/序号','物料编码','工艺编号','订单编号','工具编号'],
            tableData:[],
            editDialogVisible:false,
            data: {
				token: localStorage.getItem("token"),
            },
            editForm:{
                type:null,
                rule:[],
                codeType:null,
            },
            selectOption:[],
            selectOption1:[],
            selectOption2:[],
            selectOption3:[],
            showTitle:'',
            isSmall:false,
            permission:JSON.parse(localStorage.getItem("permission")) 
        }
    },   
    mounted:function(){
        this.initTable();
        let w  = document.documentElement.clientWidth || document.body.clientWidth;
         w>=1900?this.W = true:this.W = false
         if(w<=1280){
             this.isSmall = true
         }else{
            this.isSmall = false 
         }
        window.onresize=()=>{
            let w  = document.documentElement.clientWidth || document.body.clientWidth;
            w>=1900?this.W = true:this.W = false
            if(w<=1280){
                this.isSmall = true
            }else{
                this.isSmall = false 
            }
        }
        
    },
    deactivated:function(){
        console.log("deactivated");
    },
    computed:{
        span(){
           return this.W?5:7
        }
    },
    methods:{
        parseType(row){
            return this.typeOption[row.ruleType]
        },
        parseRuleType(row){
            if(row.codeRuleDetailList&&row.codeRuleDetailList.length>0){
                let str = ''
                row.codeRuleDetailList.forEach((item,index) => {
                    if(index==row.codeRuleDetailList.length-1){
                        str+=this.ruleTypeOption[item.ruleGenerateType]+''
                    }else{
                        str+=this.ruleTypeOption[item.ruleGenerateType]+'+'
                    }
                    
                });
                return str
            }
        },
        parseCodeType(row){
            return this.codeTypeOption[row.codeType]
        },
        parseTime(row){
            if(row.gmtModified){
                return commonUtils.timestampToDate(row.gmtModified)
            }
        },
        showEdit(row){
            this.editForm.id = row.id
            this.editForm.type = row.ruleType
            this.editForm.codeType = row.codeType
            this.editForm.rule = commonUtils.cloneObj([...row.codeRuleDetailList])
            if(row.ruleType==2){
                this.selectOption = [
                    {name:'生成时间(年 月 日)',value:0},
                    {name:'生成时间(时 分 秒)',value:1},
                    {name:'顺序/序号',value:2},
                ]
            }else if(row.ruleType==3){
                this.selectOption = [
                    {name:'生成时间(年 月 日)',value:0},
                    {name:'生成时间(时 分 秒)',value:1},
                    {name:'顺序/序号',value:2},
                    {name:'物料编码',value:3},
                    {name:'工艺编号',value:4}, 
                    {name:'订单编号',value:5},
                ]
                this.selectOption1 = commonUtils.cloneObj(this.selectOption)     
                this.selectOption2 = commonUtils.cloneObj(this.selectOption) 
                this.selectOption3 = commonUtils.cloneObj(this.selectOption) 
                this.selectChange(1)
            }
            let str = ''
            switch (row.ruleType){
                case 0:
                    str = '订单条码编辑'
                break;
                case 1:
                    str = '物料条码编辑'
                break;
                case 2:
                    str = '工艺条码编辑'
                break;
                case 3:
                    str = '订单工序条码编辑'
                break;
                case 4:
                    str = '工具条码编辑'
                    break;
            }
            this.showTitle = str
            this.editDialogVisible = true
        },
        selectChange(ev){
            let ev0 = this.editForm.rule[0].ruleGenerateType
            let ev1 = this.editForm.rule[1].ruleGenerateType
            let ev2 = this.editForm.rule[2].ruleGenerateType
            this.selectOption1.forEach(item=>{
                if(item.value==ev2||item.value==ev1){
                    item.disabled = true
                }else{
                    item.disabled = false
                }
            })
            
            this.selectOption2.forEach(item=>{
                if(item.value==ev0||item.value==ev2){
                    item.disabled = true
                }else{
                    item.disabled = false
                }
            })
            
            this.selectOption3.forEach(item=>{
                if(item.value==ev1||item.value==ev0){
                    item.disabled = true
                }else{
                    item.disabled = false
                }
            })
        },
        updateEdit(){
            let params = {
                codeRuleId: this.editForm.id,
                ruleType:this.editForm.type,
                codeType:this.editForm.codeType,
                detailList:[...this.editForm.rule]
            }
            this.$RequestUtil.post({
                url: '/api/codeRule/updateCodeRule',
                type:'sync',
				params,
                success: (res) => {
                    if(res.code == 0){
                        this.$message.success('编辑成功')
                        if(this.editForm.type==1){
                            this.$store.commit("add_reloadPages",['/Material/Material','/MasterData/ToolMgt']);
                        }
                        this.initTable()
                        this.closeEdit()
                    }else{
                        this.$message.error(res.msg||res.message);
                    }
                }
            });
        },
        closeEdit(){
            this.editDialogVisible = false
        },
        search:function(){
            this.$RequestUtil.get({
                url: '/api/codeRule/listCodeRule',
                type:'sync',
				params: {},
                success: (res) => {
                    if(res.code == 0){
                        this.tableData = res.data;
                        //临时过滤掉工具条码配置
                        // this.tableData = this.tableData.filter(item=>item.ruleType!=4) 
                    }else{
                        this.$message.error(res.msg||res.message);
                        
                    }
                }
            });
        },
        initTable:function(){
            this.search();
        },
        addWindowShow:function(){
            
        },
    }
}
</script>

<style>
  .device-msg .el-scrollbar__wrap{
        overflow-x: hidden;
        max-height:500px;
        height: auto;
        overflow-x: hidden;
        margin-bottom: 0px !important;
    }
  .import_upload>.el-upload-list{
      display: none;
   }
  .el-date-editor.el-input, .el-date-editor.el-input__inner{
      width:356px
  }
  /* .deviceTable .cell{
    padding-right:0px;
     overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
} */
.table_searchbar .el-button--mini, .el-button--mini.is-round {
    padding: 7px 10px;
}
.device-msg .el-timeline-item__node--large{
     
    left: -6px;
    width: 22px;
    height: 22px;

}
 .select_width{
	width: 180px;
}
.device-msg .el-menu-item.is-active{
    color: #303133;
}
</style>
<style scoped>

.table_searchbar .title11{
    color:  #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
}
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}

.table_searchbar{
    width:100%;
    margin-top: 10px;
    margin-bottom: 20px;
}
.import_upload{
	display: inline;
}
.page{
    display: flex;
    justify-content: flex-end;
}

.total_page{
    margin-top: 20px;
    margin-right: 26px;
    color:#606266;
    font-size: 14px;
}

.file-warp{
    height: 33px;
}
.file-img{
    width:26px;
    height: 33px;
    margin-right: 4px;
    display: inline-block;

}
.file-name{
    top: -10px;
    position: relative;
}
@media screen and (max-width: 1380px){
    .page{
        display: flex;
        justify-content: flex-end;
        margin-bottom:30px;
    }
}
.key{
    font-size: 16px;
    color:#c0c4cc;
    font-family: NotoSansHans-Regula;
    padding-right:10px;
    line-height:3
}
.addForm .value{
    display: inline-block;
    max-width: 180px;
}
.addForm .title{
    width: 70px;
    text-align: right;
    display:inline-block
}
.value{
    font-size:16px;
    color:#999;
    font-family: NotoSansHans-Regula;
    
    line-height: 3;
}
.view-form {
    width:90%;
    margin-left:10%
}
.qrcode_div{
    text-align:center;
}
</style>





// WEBPACK FOOTER //
// src/views/masterdata/QRCodeConfig.vue